import React, { useEffect, useState } from 'react';
import CreateStorePopup from './stores/CreateStorePopup';
import { Button } from 'reactstrap';
import { useSelector } from 'react-redux';
import axios from 'axios'; // Import axios for API calls
import adminApi from '../../services/adminApi';

export default ({ selectedBrand: brandProp, countryProp, brandId }) => {
  const { organizationTree, countries } = useSelector(
    (state) => state?.organization
  );
  const { brands } = organizationTree;

  const [selectedBrand, setSelectedBrand] = useState(brandProp);
  const [selectedCountry, setSelectedCountry] = useState(countryProp);
  const [selectedStores, setSelectedStores] = useState([]);

  useEffect(() => {
    try {
      if (selectedBrand?.brandId) {
        setSelectedCountry(selectedBrand?.countryList?.[0] || null);
      }
    } catch (e) {
      console.log(e);
    }
  }, [selectedBrand, brandId]);

  useEffect(() => {
    if (brandProp) {
      setSelectedBrand(brandProp);
    }
  }, [brandProp]);
  useEffect(() => {
    if (countryProp) {
      setSelectedCountry(countryProp);
    }
  }, [countryProp]);
  useEffect(() => {
    setSelectedBrand(brands?.find(({ brandId: id }) => brandId === id));
  }, [brands]);

  const handleDeleteStore = async ({ storeId }) => {
    const userConfirmed = window.confirm(
      'Are you sure you want to delete this store?'
    );
    if (!userConfirmed) return;

    try {
      const response = await adminApi.delete(`/api/stores/${storeId}`); // Replace with actual API endpoint
      if (response.status === 200) {
        setSelectedCountry((prev) => ({
          ...prev,
          stores: prev.stores.filter((store) => store.id !== storeId),
        }));
        alert('Store deleted successfully');
      }
    } catch (error) {
      console.error('Error deleting store:', error);
      alert('Failed to delete store');
    }
  };

  return (
    <>
      <div className="d-flex flex-row mt-3 gap-2">
        {selectedBrand?.countryList?.map((country) => (
          <span
            key={country?.countryCode}
            onClick={() => setSelectedCountry(country)}
            className={`cursor-pointer px-3 py-2 border rounded fs-14 ${
              country?.countryCode === selectedCountry?.countryCode
                ? 'border-primary'
                : ''
            }`}
          >
            <strong>{`${country?.flag} ${country?.name}`}</strong>
          </span>
        ))}
      </div>

      <div className="position-relative d-flex flex-column mt-4">
        <div className="d-flex flex-row align-items-center justify-content-between mb-3">
          <div className="d-flex flex-row align-items-center">
            <div
              style={{
                width: 5,
                height: 20,
                backgroundColor: '#4b38b3',
                marginRight: 8,
              }}
            />
            <span className="fs-16">
              <strong>Available Stores</strong>
            </span>
          </div>
          <CreateStorePopup
            store={{
              organizationId: organizationTree?.organizationId,
              brandId: selectedBrand?.brandId,
              countryCode: selectedCountry?.countryCode,
            }}
          />
        </div>

        <table className="table table-nowrap table-centered align-middle mb-0">
          <thead className="bg-light fs-14">
            <tr>
              <th>#</th>
              <th>Store Name</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody className="fs-13">
            {selectedCountry?.stores?.length > 0 ? (
              selectedCountry?.stores?.map((store, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{store?.name}</td>
                  <td>{store?.isDisabled ? 'Disabled' : 'Active'}</td>
                  <td>
                    <CreateStorePopup store={{ ...store }} />

                    <Button
                      type="button"
                      className="badge btn btn-danger py-2 ms-2"
                      onClick={() => handleDeleteStore(store)}
                    >
                      <i className="ri-delete-bin-line fs-18"></i>
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center text-muted">
                  No stores available for the selected country.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};
